
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/como-comprar",
      function () {
        return require("private-next-pages/como-comprar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/como-comprar"])
      });
    }
  